<div [class]="'repeat-container ' + className">
  <span class="repeat-state" (click)="expand()">
    <span class="repeat-state-title">{{states[state]}}</span>
    <i class="bx bx-caret-down"></i>
  </span>

  <div *ngIf="isExpanded" class="repeat-expand">
    <ul>
      <li *ngFor="let s of states; let i = index" class="repeat-item" (click)="selectState(i)">
        <i *ngIf="i!==state" class="bx bx-radio-circle large"></i>
        <i *ngIf="i===state" class="bx bx-radio-circle-marked large"></i>
        <span class="repeat-item-title">{{s}}</span>
      </li>
    </ul>
  </div>
</div>